export type ModoImportacionSaldosCtaCte = 'clientes' | 'proveedores';

export const COLUMNA_ID_CLIENTE = 'nroCliente' as const;
export const COLUMNA_ID_PROVEEDOR = 'nroProveedor' as const;

export const COLUMNAS_COMUNES_IMPORT_SALDOS = [
  'tipo',
  'nroDocumento',
  'fechaEmision',
  'fechaVencimiento',
  'saldoActual',
  'moneda',
  'codigoArticulo',
  'descripcion',
] as const;

export const getColumnasImportSaldos = (modo: ModoImportacionSaldosCtaCte): string[] => [
  modo === 'clientes' ? COLUMNA_ID_CLIENTE : COLUMNA_ID_PROVEEDOR,
  ...COLUMNAS_COMUNES_IMPORT_SALDOS,
];

/** Campos obligatorios en cada fila (descripcion es opcional). */
export const getCamposRequeridosImportSaldos = (modo: ModoImportacionSaldosCtaCte): string[] =>
  getColumnasImportSaldos(modo).filter((c) => c !== 'descripcion');

export const CAMPOS_NUMERICOS_IMPORT_SALDOS = [
  'nroProveedor',
  'saldoActual',
  'moneda',
] as const;

export const INSTRUCCIONES_IMPORT_SALDOS: [string, string, string][] = [
  ['tipo', 'Tipo', 'CREDITO (80) o DEBITO (81). También acepta 80 / 81'],
  [
    'nroDocumento',
    'Nro. documento original',
    'Número del comprobante original que se migra (queda como detalle; no numera el saldo interno X)',
  ],
  ['fechaEmision', 'Fecha emisión', 'Formato fecha (AAAA-MM-DD o Excel)'],
  ['fechaVencimiento', 'Fecha vencimiento', 'Formato fecha (AAAA-MM-DD o Excel)'],
  ['saldoActual', 'Saldo actual', 'Saldo pendiente (≥ 0). Se graba como ImporteTotal completo'],
  ['moneda', 'Moneda', 'Código numérico de moneda (CodigoMoneda)'],
  ['codigoArticulo', 'Código artículo', 'Artículo del renglón y cuenta contable (obligatorio)'],
  [
    'descripcion',
    'Descripción',
    'Opcional. Si está en blanco, se usa la descripción del artículo',
  ],
];
